var onFocusValidation = Class({
  initialize: function () {
    this.errorContainerClass = 'error-container';
    this.validContainerClass = 'valid-container';
    this.errorClass = 'ui-state-error';
    this.creditcardId = $('#WC_PaymentInfoForm_creditCardNumber_1');
  },

  success: function ($currentEl, isOnFocus) {
    $currentEl.closest(".wcs-row").removeClass(this.errorContainerClass).addClass(this.validContainerClass);
    $currentEl.closest(".rb-fieldrow").removeClass('rb-invalidrow').addClass('rb-validrow rb-floating');
  },

  error: function ($currentEl) {
    $currentEl.closest(".wcs-row").addClass('error-container').removeClass(this.validContainerClass);
    $currentEl.closest(".rb-fieldrow").addClass('rb-invalidrow').removeClass('rb-validrow');
  },

  default: function ($currentEl) {
    $currentEl.closest(".wcs-row").removeClass(this.validContainerClass).removeClass(this.errorContainerClass);
    $currentEl.closest(".rb-fieldrow").removeClass('rb-validrow').removeClass('rb-invalidrow');
  },

  fullError: function ($currentEl) {
    $currentEl.closest(".wcs-row").addClass(this.errorContainerClass).removeClass(this.validContainerClass);
    $currentEl.closest(".rb-fieldrow").addClass('rb-invalidrow').removeClass('rb-validrow');
    show_error($currentEl);
    $currentEl.addClass(this.errorClass);
  },

  simpleValidation: function ($currentEl, isOnFocus) {
    var self = this;
    if ($currentEl.val() === "") {
      self.default($currentEl)
    } else {
      self.success($currentEl, isOnFocus)
    }
  },

  simpleFullValidation: function ($currentEl, isOnFocus) {
    var self = this;
    if ($currentEl.val() === "") {
      self.fullError($currentEl)
    } else {
      self.success($currentEl, isOnFocus)
    }
  },

  simpleValidationShowError: function ($currentEl) {
    var self = this;
    if ($currentEl.val() === "") {
      self.fullError($currentEl)
    }
  },

  cardValidation: function ($currentField, isOnFocus) {
    var self = this;
    var cardsList16Digits = ['visa', 'discover', 'mastercard', 'hipercard', 'elo', 'jcb'];
    var $cardType = $.trim($.payment.cardType($(this.creditcardId).val()));
    ccId = $('#WC_PaymentInfoForm_creditCardNumber_1');   
    sixteenDigitCards = ccId.attr('class').split(' ').some(elem => cardsList16Digits.indexOf(elem) >= 0);
		fifteenDigitCards =  $('#WC_PaymentInfoForm_creditCardNumber_1' ).hasClass('amex');
		fourteenDigitCards =  $('#WC_PaymentInfoForm_creditCardNumber_1' ).hasClass('dinersclub');
    var ccValue = ccId.val().replace(/\s/g, "");
		
    if ($cardType !== "" && ((sixteenDigitCards && ccValue.length > 15) || (fifteenDigitCards && ccValue.length > 14) || (fourteenDigitCards && ccValue.length > 13) )) {
      self.success($currentField, isOnFocus);
    } else {
      self.fullError($currentField);
    }
  },

  expDateValidation: function ($currentField, $month, $year, isOnFocus) {
    var self = this;
    var $today = new Date();
    var $selDate = new Date();
    if ($currentField.val() === "") {
      self.default($currentField);
    } else if (($today.getTime() > $selDate.setFullYear($year.val(), $month.val())) || $month.val() > 12) {
      self.fullError($currentField);
    } else {
      self.success($currentField, isOnFocus);
    }
  },

  cvcValidation: function ($currentField, isOnFocus) {
    var self = this;
    var $cardType = $.trim($.payment.cardType($(this.creditcardId).val()));
    if (($cardType === 'amex' && $currentField.val().length < 4) || ($cardType !== 'amex' && $cardType !== null && $cardType !== undefined && $currentField.val().length < 3)) {
      self.fullError($currentField);
    } else if ($currentField.val() === "") {
      self.default($currentField);
    } else {
      self.success($currentField, isOnFocus);
    }
  },

  fiscalCodeValidationIT: function ($cf, isOnFocus) {
    var self = this;
      if (window.validateFiscalCode($cf.val()) === true && $cf.val() !== "") {
        self.success($cf, isOnFocus);
      } else if ($cf.val() === "") {
        self.default($cf)
      } else {
        self.fullError($cf)
      }
  },
})
